import { useEffect, useState } from "react";
import Header from "../../components/Header";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Sidebar from "../../components/Sidebar";
import axios from "axios";
import { BASE_URL, EDIT_CONSULTATION_CHAT, GET_CONSULTATION_CHAT, TOKEN } from "../../API";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import card3 from "../../Assets/Images/AIImg.png";
import card2 from "../../Assets/Images/user2.png";
import { GoDotFill } from "react-icons/go";
import { Link, useLocation } from "react-router-dom";
import moment from "moment";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import Flag from "../../Assets/Images/pencil.png";

function DiagnosticSuggestionsView() {
  const location = useLocation();
  const { consultData } = location.state || {}
  const token = localStorage.getItem("token");
  const [isLoading, setIsLoading] = useState(false);
  const [chatData, setChatData] = useState([]);
  const [editedMessages, setEditedMessages] = useState({});
  const [isEditable, setIsEditable] = useState(false);

  useEffect(() => { getConsultationChat() }, []);

  const handleMessageChange = (messageId, value) => {
    setEditedMessages((prev) => ({
      ...prev,
      [messageId]: value,
    }));
  };

  const handleFlagClick = (messageId, currentMessage) => {
    setIsEditable(isEditable === messageId ? null : messageId);
    setEditedMessages((prev) => ({
      ...prev,
      [messageId]: currentMessage,
    }));
  };

  const handleEditMessage = async (messageId) => {
    // setIsLoading(true)
    const formData = new FormData();
    formData.append("messageId", messageId);
    formData.append("newMessage", editedMessages[messageId] || "");
    const headers = { "token": TOKEN };

    try {
      const response = await axios.put(BASE_URL + EDIT_CONSULTATION_CHAT, formData, { headers });
      if (response.data.code === 200 && response.data.status === true) {

        setChatData((prev) =>
          prev.map((chat) =>
            chat._id === messageId ? { ...chat, message: editedMessages[messageId] } : chat
          )
        );
        setIsEditable(null); // Exit edit mode
        setEditedMessages((prev) => {
          const updated = { ...prev };
          delete updated[messageId]; // Clear the edited message
          return updated;
        });


      }
    } catch (error) {
      if (error.response && error.response.data) {
        const errorMessage = error.response.data.error || "An error occurred";
        toast.error(errorMessage);
      }
      else { toast.error("An error occurred") }
    }
  };


  const getConsultationChat = async () => {
    setIsLoading(true);
    const headers = { token: token };
    try {
      const response = await axios.get(`${BASE_URL}${GET_CONSULTATION_CHAT}?id=${consultData?._id}`, { headers });
      const json = response.data;
      if (json.code === 200 && json.status === true) { setChatData(json.data) }
      else { console.log("Error fetching products"); }
    } catch (err) { console.error("Best season product fetch error:", err); }
    finally { setIsLoading(false) }
  };

  return (
    <div className="container-fluid">
      <Header />
      <div className="row">
        <Sidebar />
        <div className="col-9 main-dash-left">
          <section className="back-dashboard-sec comn-dashboard-page">
            <div className="cstm_bredcrumb_outer">
              <Breadcrumb
                className="cstm_bredcrumb"
                listProps={{ className: "breadcrumb-custom-separator" }}>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/diagnostic-suggestions" }}>
                  Diagnostic Suggestions
                </Breadcrumb.Item>
                <Breadcrumb.Item active href="javscript:void(0);">
                  View Details
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <div className="notifi-list d-flex">
              <h6 className="comm_page_heading mb-0">Diagnostic Suggestions Details</h6>
            </div>
            <Row className="row-gap-5">
              <Col lg={8}>
                <h5 className="comm_inner_sub_heading"> Conversation Details </h5>
                <div className="ai_chat_box_left">
                  <div className="chat-main">
                    <div className="all-chat-main">
                      {chatData && chatData.length > 0 ?
                        chatData.map((data, index) => {
                          // const senderChat = data.filter((data) => data.sender === "User")
                          return (
                            <>
                              <div key={data?._id || index}>

                                {data?.sender === 'User' ?
                                  <div className="d-flex flex-column chat_box">
                                    <div className="chat_inn_box second_user_txt-flex">
                                      <div className="img-chat-date d-flex">
                                        <div className="profile-chat-img">
                                          <img src={card2} alt="" className="img-fluid" />
                                        </div>
                                        <div className="chat_box_outer">
                                          <div className="chat-box">
                                            <p className="chat_text second_user_txt">
                                              {data?.message}
                                            </p>
                                            <span className="cs_chat_time second">
                                              {/* <img src={Flag} alt="" className="img-fluid" /> */}
                                              {moment(Number(data.createdAt)).format("hh:mm A")}
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                  :
                                  <div className="d-flex flex-column chat_box">
                                    <div className="chat_inn_box">
                                      <div className="img-chat-date d-flex">
                                        <div className="profile-chat-img">
                                          <img src={card3} alt="" className="img-fluid" />
                                        </div>
                                        <div className="chat_box_outer">
                                          <div className="chat-box">
                                            <Form.Group className="comn-class-inputs">
                                              <Form.Control
                                                type="text"
                                                as="textarea"
                                                value={editedMessages[data._id] || data.message}
                                                onChange={(e) => handleMessageChange(data._id, e.target.value)}
                                                placeholder="Enter Your Notes Here"
                                                style={{ height: "90px", width: "100%", resize: "none" }}
                                                disabled={isEditable !== data?._id} className="chat_text first_user_txt"

                                              />
                                            </Form.Group>
                                            <span className="cs_chat_time first">
                                              <img
                                                src={Flag}
                                                alt="" className="img-fluid"
                                                onClick={() => handleFlagClick(data?._id, data.message)}
                                                style={{ cursor: 'pointer' }}

                                              />
                                              7:51 PM
                                            </span>
                                          </div>
                                          {isEditable === data?._id && (

                                            <div className="d-flex inner_chat_btn_grp">
                                              <button
                                                className="discard_btn"
                                                onClick={() => setIsEditable(null)}

                                              >
                                                Discard Changes
                                              </button>
                                              <button
                                                className="main-btn chat_inner_btn"
                                                onClick={() => handleEditMessage(data._id)}
                                                disabled={isLoading}
                                              >
                                                Save
                                              </button>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  // <div className="d-flex flex-column chat_box">
                                  //   <div className="chat_inn_box">
                                  //     <div className="img-chat-date d-flex">
                                  //       <div className="profile-chat-img">
                                  //         <img src={card3} alt="" className="img-fluid" />
                                  //       </div>
                                  //       <div className="chat_box_outer">
                                  //         <div className="chat-box">
                                  //           <p className="chat_text first_user_txt">
                                  //             {data?.message}
                                  //           </p>
                                  //           <span className="cs_chat_time first">
                                  //             {moment(Number(data.createdAt)).format("hh:mm A")}
                                  //           </span>

                                  //         </div>
                                  //       </div>
                                  //     </div>
                                  //   </div>
                                  // </div>
                                }

                              </div>
                            </>

                          )
                        })
                        :
                        <h6>No Conversation Found!!</h6>
                      }
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={4}>
                <h5 className="comm_inner_sub_heading"> Patient Details: </h5>
                <div className="patient-detail-outer">
                  <div className="patient-anme-view">
                    <h5>patient ID:</h5>
                    <p>#{consultData?.user_id?.patient_id}</p>
                  </div>
                  <div className="patient-anme-view">
                    <h5>patient name:</h5>
                    <p>{consultData?.user_id?.full_name}</p>
                  </div>
                  <div className="patient-anme-view">
                    <h5>Phone Number:</h5>
                    <p>326547894</p>
                  </div>
                  <div className="patient-anme-view">
                    <h5>Email:</h5>
                    <p>{consultData?.user_id?.email}</p>
                  </div>

                  <div className="patient-anme-view">
                    <h5>date of consultation:</h5>
                    <p>{moment(Number(consultData?.createdAt)).format("DD-MM-YYYY")}</p>
                  </div>
                  <div className="patient-anme-view">
                    <h5>age:</h5>
                    <p>{consultData?.age}</p>
                  </div>
                  <div className="patient-anme-view">
                    <h5>Gender:</h5>
                    <p>{consultData?.gender}</p>
                  </div>

                  <div className="patient-anme-view">
                    <h5>Condition:</h5>
                    <p>{consultData?.condition || 'Not Specified'}</p>
                  </div>
                  <div className="patient-anme-view">
                    <h5>status:</h5>
                    {consultData?.is_approved
                      ?
                      <div className="pending-status completed">
                        <GoDotFill />
                        Completed
                      </div>
                      :
                      <div className="pending-status">
                        <GoDotFill />
                        Pending
                      </div>
                    }


                  </div>
                </div>
              </Col>
            </Row>
            {consultData?.is_approved ?
              null
              :

              <div className="d-flex comm_same_wid_btns">
                <button className="main-btn chat_bottom_btn mt-0" >
                  Apporve
                </button>
                <button className="main-outline-btn chat_bottom_btn mt-0" >
                  Discard
                </button>
              </div>
            }

          </section>
        </div>
      </div>
    </div>
  );
}

export default DiagnosticSuggestionsView;
